import { createStructuredSelector } from 'reselect';

import { getCurrencyCode, getLanguageCode } from '../modules/app/selectors';
import { ApplicationState } from '../types';

export const localizationMapper = createStructuredSelector<
    ApplicationState,
    { languageCode: string | undefined; currencyCode: string | undefined }
>({
    languageCode: getLanguageCode,
    currencyCode: getCurrencyCode,
});
